<template>
	<div class="page">
		<div class="page-title bg-white padding-lr flex justify-between align-center shadow-warp border-bottom">
			<div class="text-lg text-bold">
				<i class="el-icon-caret-right"></i>
				{{ $route.meta.title }}
			</div>
		</div>
		<div class="page-main">
			<div class="padding bg-white shadow-warp">
				<el-form ref="formAdd" :model="formAdd" label-width="150px" label-suffix=":">
					<el-divider content-position="left" class="margin-tb-xl">基础资料</el-divider>
					<el-form-item label="服务项目">
						<el-select v-model="formAdd.product" @change="changeProduct" @visible-change="changeVisibleProduct">
							<div
								class="padding-tb-xl text-center text-df"
								v-loading="loadingProduct"
								element-loading-spinner="el-icon-loading"
								element-loading-text="加载中..."
								slot="empty"
							>
								<div>未找到产品，请先设置产品：</div>
								<div class="text-bold text-blue">
									<i class="el-icon-right"></i>
									系统->产品管理
								</div>
							</div>
							<el-option :value="item.id" :label="item.name" v-for="(item, index) in productList" :key="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="合同编号" prop="number" :rules="{ required: true, message: '请输入合同编号', trigger: 'blur' }">
						<el-input v-model="formAdd.number" placeholder="合同编号" autocomplete="off" style="width: 220px;"></el-input>
					</el-form-item>
					<el-form-item label="关联客户" prop="customer" :rules="{ required: true, message: '请选择客户信息', trigger: 'blur' }">
						<el-button size="small" type="" plain class="radius text-gray" @click="checkCustomerShow = true">
							<div class="flex align-center">
								<div class="text-left" style="line-height: 22px;" v-if="customer">
									<div class="flex align-center">
										<span class="text-bold text-black text-df">{{ customer.name }}</span>
										<el-tag size="mini" class="margin-left-sm">公司</el-tag>
									</div>
									<div class="text-grey">{{ customer.credit_code }}</div>
								</div>
								<div class="text-center" v-else><span>点击选择客户</span></div>
								<div class="margin-left"><span class="iconfont-genghuan" style="font-size: 32px;"></span></div>
							</div>
						</el-button>
						<check-customer :show="checkCustomerShow" :current="customer" @close="checkCustomerShow = false" @check="checkCustomerChange"></check-customer>
					</el-form-item>
					<el-form-item label="联系人" prop="contacter" :rules="{ required: true, message: '请填写联系人', trigger: 'blur' }">
						<div class="flex align-center" v-if="customer">
							<div class="text-left" style="line-height: 22px;" v-if="contacter">
								<div class="flex align-center">
									<span :class="'text-bold ' + (contacter.gender == 2 ? 'text-pink' : contacter.gender == 1 ? 'text-blue' : 'text-black')">
										{{ contacter.name }}
									</span>
									<el-tag size="mini" type="info" class="margin-left-sm" v-if="contacter.position">{{ contacter.position }}</el-tag>
								</div>
								<div class="text-grey">{{ contacter.mobile }}</div>
							</div>
							<div class="text-center" v-else><span>点击选择</span></div>
							<el-button size="small" type="text" class="radius text-gray" @click="checkContacterShow = true">
								<div class="margin-left"><span class="iconfont-genghuan" style="font-size: 24px;"></span></div>
							</el-button>
						</div>
						<div v-else class="text-orange">
							<span class="iconfont-tishi"></span>
							<span class="">请先选择客户</span>
						</div>
						<check-contacter
							:show="checkContacterShow"
							:customer="customer"
							:current="contacter"
							@close="checkContacterShow = false"
							@check="checkContacterChange"
						></check-contacter>
					</el-form-item>
					<el-form-item label="备注">
						<el-input type="textarea" placeholder="请输入内容" v-model="formAdd.remark" maxlength="140" show-word-limit rows="5" :style="{ width: '600px' }"></el-input>
					</el-form-item>
					<el-divider content-position="left" class="margin-tb-xl">服务项目内容</el-divider>
					<fieldset class="shadow shadow-lg" v-if="Object.keys(product).length > 0">
						<legend class="padding">{{product.name}}</legend>
						<el-form ref="orderForm" :model="formAdd.content" label-width="120px" label-suffix=":" class="padding-lr">
							<div v-for="(item, index) in product.orderform" :key="item.key" class="flex justify-between align-center border-bottom padding-top">
								<el-form-item :prop="item.key" :label="item.name">
									<el-input
										v-model="formAdd.content[item.key]"
										:placeholder="item.config.placeholder"
										:clearable="item.config.clearable"
										:show-word-limit="item.config.showWordLimit"
										:maxlength="item.config.maxlength ? item.config.maxlength : false"
										:minlength="item.config.minlength ? item.config.minlength : false"
										:style="{ width: item.config.width }"
										v-if="item.type == 'input'"
									></el-input>
									<el-input
										type="textarea"
										v-model="formAdd.content[item.key]"
										:placeholder="item.config.placeholder"
										:clearable="item.config.clearable"
										:show-word-limit="item.config.showWordLimit"
										:maxlength="item.config.maxlength ? item.config.maxlength : false"
										:minlength="item.config.minlength ? item.config.minlength : false"
										:rows="item.config.rows"
										:style="{ width: item.config.width }"
										v-if="item.type == 'textarea'"
									></el-input>
									<el-input-number
										v-model="formAdd.content[item.key]"
										:placeholder="item.config.placeholder"
										:max="item.config.max"
										:min="item.config.min"
										:step="item.config.step"
										:step-strictly="item.config.stepStrictly"
										:precision="item.config.precision"
										:controls="item.config.controls"
										v-if="item.type == 'inputNumber'"
									></el-input-number>
									<el-radio-group v-model="formAdd.content[item.key]" v-if="item.type == 'radio'">
										<template v-if="item.config.type == 'radio'">
											<el-radio :label="val" :border="item.config.border" v-for="(val, idx) in item.config.values" :key="idx"></el-radio>
										</template>
										<template v-if="item.config.type == 'button'">
											<el-radio-button
												:label="val"
												:border="item.config.border"
												v-for="(val, idx) in item.config.values"
												:key="idx"
											></el-radio-button>
										</template>
									</el-radio-group>
									<el-checkbox-group
										v-model="formAdd.content[item.key]"
										:min="item.config.min"
										:max="item.config.max ? item.config.max : 99"
										v-if="item.type == 'checkbox'"
									>
										<el-checkbox :label="val" :border="item.config.border" v-for="(val, idx) in item.config.values" :key="idx">{{ val }}</el-checkbox>
									</el-checkbox-group>
									<el-select v-model="formAdd.content[item.key]" v-if="item.type == 'select'">
										<el-option :value="val" v-for="(val, idx) in item.config.values" :key="idx">{{ val }}</el-option>
									</el-select>
									<el-select
										v-model="formAdd.content[item.key]"
										multiple
										:collapse-tags="item.config.collapseTags"
										:multipleLimit="item.config.multipleLimit"
										v-if="item.type == 'selectMultiple'"
									>
										<el-option :value="val" v-for="(val, idx) in item.config.values" :key="idx">{{ val }}</el-option>
									</el-select>
									<el-switch
										v-model="formAdd.content[item.key]"
										:inactive-value="item.config.inactiveValue"
										:active-value="item.config.activeValue"
										:active-color="item.config.activeColor"
										:inactive-color="item.config.inactiveColor"
										v-if="item.type == 'switch'"
									></el-switch>
									<el-date-picker
										v-model="formAdd.content[item.key]"
										:type="item.config.type"
										:format="item.config.format"
										:value-format="item.config.format"
										placeholder="请选择"
										v-if="item.type == 'datePicker' || item.type == 'datePickerRange'"
									></el-date-picker>
									<form-item-customer v-model="formAdd.content[item.key]" :multiple="item.config.multiple" v-if="item.type == 'customer'"></form-item-customer>
									<form-item-employee v-model="formAdd.content[item.key]" :multiple="item.config.multiple" v-if="item.type == 'employee'"></form-item-employee>
								</el-form-item>
								<div class="text-right" style="width: 200px;">
									<el-button size="mini" type="text" class="text-orange" @click="modifyFormItem(index)">
										<i class="el-icon-edit"></i>
										<span>修改</span>
									</el-button>
									<el-button size="mini" type="text" class="text-gray" @click="deleteFormItem(index)">
										<i class="el-icon-delete"></i>
										<span>删除</span>
									</el-button>
								</div>
							</div>
						</el-form>
					</fieldset>
					<fieldset class="shadow shadow-lg">
						<legend class="padding">{{ serviceItem.name }}</legend>
						<el-form-item :label="item.name" :prop="'service.content.' + item.key" :rules="item.rule" v-for="(item, index) in serviceItem.formItem" :key="item.key">
							<template v-if="item.type == 'input'">
								<el-input v-model="formAdd.service.content[item.key]" :placeholder="item.placeholder" style="width: 220px;"></el-input>
								<span class="margin-left-sm">{{ item.tip }}</span>
							</template>
							<el-select v-model="formAdd.service.content[item.key]" v-else-if="item.type == 'select'">
								<el-option v-for="(val, idx) in item.values" :key="idx" :value="val" :label="val"></el-option>
							</el-select>
							<el-radio-group v-model="formAdd.service.content[item.key]" v-else-if="item.type == 'radio'">
								<el-radio v-for="(val, idx) in item.values" :key="idx" :label="val">{{ val }}</el-radio>
							</el-radio-group>
							<template v-else-if="item.type == 'date'">
								<el-date-picker v-model="formAdd.service.content[item.key]" :placeholder="item.placeholder" type="month"></el-date-picker>
								<span class="margin-left-sm">{{ item.tip }}</span>
							</template>
							<template v-else-if="item.type == 'number'">
								<el-input-number v-model="formAdd.service.content[item.key]" :step="item.step" :min="item.min" :step-strictly="item.strictly"></el-input-number>
								<span class="margin-left-sm">{{ item.tip }}</span>
							</template>
						</el-form-item>
					</fieldset>
					<el-divider content-position="left" class="margin-tb-xl">财务信息</el-divider>
					<el-form-item label="订单金额">
						<span class=" text-lg text-blue text-bold" v-format="'[<1000]0.00;#,##0.00'">{{ formAdd.money }}</span>
						元
					</el-form-item>
					<el-form-item label="已收金额">
						<span class=" text-lg text-cyan text-bold" v-format="'[<1000]0.00;#,##0.00'">{{ formAdd.money }}</span>
						元
					</el-form-item>
					<el-form-item label="未收金额">
						<span class=" text-lg text-red text-bold" v-format="'[<1000]0.00;#,##0.00'">{{ formAdd.money }}</span>
						元
					</el-form-item>
					<el-form-item label="收款计划">
						<el-table class="border" :data="formAdd.receivable">
							<el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
							<el-table-column prop="money" label="应收金额" align="right">
								<template slot-scope="scope">
									<span class=" text-blue text-bold" v-format="'[<1000]0.00;#,##0.00'">{{ scope.row.money }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="receiptDate" label="预计收款时间" align="center"></el-table-column>
							<el-table-column prop="payState" label="收款状态" align="center">
								<template slot-scope="scope">
									<el-tag type="success" size="small" effect="plain" v-if="scope.row.payState == 1">已收</el-tag>
									<el-tag type="info" size="small" effect="plain" v-else>未收</el-tag>
								</template>
							</el-table-column>
							<el-table-column prop="payMoney" label="收款金额" align="right">
								<template slot-scope="scope">
									<span class="text-cyan text-bold" v-format="'#,##0.00'">{{ scope.row.payMoney }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="payDate" label="收款时间" align="center"></el-table-column>
							<el-table-column label="操作">
								<template slot-scope="scope">
									<el-button type="warning" size="mini" @click="modifyReceivable(scope.$index)">
										<i class="el-icon-edit"></i>
										<span>修改</span>
									</el-button>
									<el-button type="infor" size="mini" @click="deleteReceivable(scope.$index)">
										<i class="el-icon-delete"></i>
										<span>删除</span>
									</el-button>
								</template>
							</el-table-column>
						</el-table>
						<el-button class="margin-top" type="text" @click="dialogVisibleReceivableAdd = true">
							<i class="el-icon-plus"></i>
							<span>添加收款计划</span>
						</el-button>
					</el-form-item>
					<el-divider content-position="left" class="margin-tb-xl">附件</el-divider>
					<!--
					<el-form-item label="图片" prop="ext.product.picture">
						<el-upload
							class="avatar-uploader"
							action="#"
							list-type="picture-card"
							:auto-upload="true"
							:http-request="upload_upload"
							:on-preview="upload_preview"
							:on-remove="upload_picture_remove"
							:on-change="upload_picture_change"
							:before-upload="upload_before"
							:class="{ hide: hideUpload_picture }"
							:multiple="true"
							:limit="9"
							:on-exceed="upload_exceed"
							accept="image/png, image/jpeg"
						>
							<i slot="default" class="el-icon-plus"></i>
							<div slot="tip" class="el-upload__tip">
								<span class="el-icon-info"></span>
								只能上传jpg/png文件，单个图片不超过2MB，最多只能上传9张
							</div>
						</el-upload>
					</el-form-item>

					<el-form-item label="其他补充文件" prop="ext.product.otherfile">
						<el-upload
							class="upload-demo"
							action="#"
							:on-preview="upload_changename"
							:on-change="upload_file_change"
							:on-remove="upload_file_remove"
							:file-list="upload_file.file"
							:auto-upload="false"
						>
							<el-button slot="trigger" size="small">选取文件</el-button>
							<div slot="tip" class="el-upload__tip">只能上传zip/rar/doc/docx/txt/jpg/png文件，且不超过2MB</div>
						</el-upload>
					</el-form-item>
					-->
					<el-divider content-position="left"></el-divider>
					<el-form-item>
						<el-button type="primary" @click="formSubmitAdd('formAdd')">提交订单</el-button>
						<el-button @click="dialogAdd = false">取 消</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<el-dialog :show-close="false" append-to-body :visible.sync="dialogVisibleReceivableAdd" width="500px">
			<div slot="title" class="flex align-center justify-between">
				<div class="flex align-center">
					<span class="el-icon-money text-gray "></span>
					<div class="margin-left-xs"><div class="text-bold">添加收款计划(应收款)</div></div>
				</div>
				<el-link :underline="false" type="info" @click="dialogVisibleModify = false"><i class="el-icon-close text-xxl"></i></el-link>
			</div>
			<el-form ref="formReceivableAdd" :model="formReceivableAdd" label-width="120px" label-suffix=":" style="padding-top: 30px; padding-right: 20px;">
				<el-form-item label="应收金额" prop="money" :rules="{ required: true, message: '请填写应收金额', trigger: 'blur' }">
					<el-input v-model="formReceivableAdd.money" placeholder="应收款金额" style="width: 220px;"></el-input>
					元
				</el-form-item>
				<el-form-item label="预计收款时间" prop="receiptDate" :rules="{ required: true, message: '请选择预计收款时间', trigger: 'blur' }">
					<el-date-picker v-model="formReceivableAdd.receiptDate" placeholder="点击选择日期"></el-date-picker>
				</el-form-item>
				<el-form-item label="联系人" prop="contacter" :rules="{ required: true, message: '请填写联系人', trigger: 'blur' }">
					<el-button size="small" type="" plain class="radius text-gray" @click="checkContacterShow = true" v-if="customer">
						<div class="flex align-center">
							<div class="text-left" style="line-height: 22px;" v-if="contacter">
								<div class="flex align-center">
									<span class="text-bold text-black text-df">{{ contacter.name }}</span>
									<el-tag size="mini" class="margin-left-sm">先生</el-tag>
								</div>
								<div class="text-grey">{{ contacter.mobile }}</div>
							</div>
							<div class="text-center" v-else><span>点击选择</span></div>
							<div class="margin-left"><span class="iconfont-genghuan" style="font-size: 32px;"></span></div>
						</div>
					</el-button>
					<div v-else class="text-orange">
						<span class="iconfont-tishi"></span>
						<span class="">请先选择客户</span>
					</div>
					<check-contacter
						:show="checkContacterShow"
						:customer="customer"
						:current="contacter"
						@close="checkContacterShow = false"
						@check="checkContacterChange"
					></check-contacter>
				</el-form-item>
				<el-form-item label="备注">
					<el-input type="textarea" placeholder="请输入内容" v-model="formReceivableAdd.remark" maxlength="140" show-word-limit rows="5"></el-input>
				</el-form-item>
				<el-divider content-position="left"></el-divider>
				<el-form-item>
					<el-button type="primary" @click="formSubmitReceivableAdd">确 定</el-button>
					<el-button @click="dialogVisibleReceivableAdd = false">取 消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog :visible.sync="dialogVisibleReceivableModify"></el-dialog>
		<el-dialog title="预览图片" :visible.sync="dialogVisible"><img width="100%" :src="dialogImageUrl" alt="" /></el-dialog>
		<check-employee :show="checkEmployeeShow" :dKey="checkEmployeeKey" @close="checkEmployeeClose" @change="changeEmployee"></check-employee>
	</div>
</template>

<script>
import checkCustomer from '@/components/check-customer.vue';
import checkContacter from '@/components/check-contacter.vue';
import checkEmployee from '@/components/check-employee.vue';
export default {
	components: { checkCustomer, checkContacter, checkEmployee },
	data() {
		return {
			orderid: '',
			hideUpload: false,
			hideUpload_picture: false,
			hideUpload_trademark: false,
			hideUpload_permit: false,
			infos_item: [],
			infos_category: [],
			regionData: this.$regionData,
			is_permit: false,
			permit_name: '许可证',
			checkCustomerShow: false,
			customer: null,
			checkContacterShow: false,
			contacter: null,
			checkEmployeeShow: false,
			checkEmployeeKey: null,
			loadingProduct: false,
			productList: [],
			product:{},
			serviceItem: {
				name: '代理记账',
				formItem: [
					{
						key: 'taxtype',
						name: '税务类型',
						placeholder: '请选择',
						type: 'select',
						value: '',
						values: ['小规模纳税人', '一般纳税人'],
						must: true,
						rule: { required: true, message: '请选择税务类型', trigger: 'blur' }
					},
					{
						key: 'taxstate',
						name: '税务状态',
						placeholder: '请选择',
						type: 'select',
						value: '正常',
						values: ['正常', '异常'],
						must: true,
						rule: { required: true, message: '请选择税务类型', trigger: 'blur' }
					},
					{
						key: 'is_zero',
						name: '是否零申报',
						placeholder: '请选择',
						type: 'radio',
						value: '否',
						values: ['是', '否'],
						must: true,
						rule: { required: true, message: '请选择税务类型', trigger: 'blur' }
					},
					{
						key: 'level',
						name: '服务级别',
						placeholder: '请选择',
						type: 'select',
						value: '基础',
						values: ['基础', '顾问', '专家'],
						must: true,
						rule: { required: true, message: '请选择服务类型', trigger: 'blur' }
					},
					{
						key: 'bank',
						name: '银行开户',
						placeholder: '请选择',
						type: 'radio',
						value: '已办理',
						values: ['已办理', '未办理'],
						must: true,
						rule: { required: true, message: '请选择银行开户状态', trigger: 'blur' }
					},
					{
						key: 'registration',
						name: '税务登记',
						placeholder: '请选择',
						type: 'radio',
						value: '已办理',
						values: ['已办理', '未办理'],
						must: true,
						rule: { required: true, message: '请选择税务登记状态', trigger: 'blur' }
					},
					{
						key: 'time',
						name: '服务时长',
						placeholder: '整数形式',
						tip: '单位：月，包括赠送的时长。',
						type: 'number',
						value: 12,
						step: 1,
						min: 0,
						strictly: true,
						must: true,
						rule: { required: true, message: '请填写服务时长，整数形式', trigger: 'blur' }
					},
					{
						key: 'zstime',
						name: '赠送服务时长',
						placeholder: '整数形式',
						tip: '单位：月。',
						type: 'number',
						value: 0,
						step: 1,
						min: 0,
						strictly: true
					},
					{
						key: 'begintime',
						name: '首次报税月份',
						placeholder: '点击选择',
						tip: '首次进行报税的月份。',
						type: 'date',
						value: ''
					}
				]
			},
			formAdd: {
				agent_id: '',
				item_id: null,
				item: {},
				money: 0,
				content: {},
				service: {
					id: '',
					name: '',
					type: '',
					content: {}
				},
				receivable: [
					{
						money: 1000,
						receiptDate: '2021-04-23',
						payState: 1,
						payMoney: 1000,
						payDate: '2021-04-23'
					},
					{
						money: 1600,
						receiptDate: '2021-04-23',
						payState: 0,
						payMoney: 0,
						payDate: ''
					}
				],
				ext: {
					customer: {
						name: '',
						creditCode: '',
						telephone: '',
						intro: '',
						region: ['610000', '610100', '610104'],
						address: '陕西省西安市莲湖区',
						linkman: {
							name: '',
							mobile: ''
						},
						license: null
					},
					product: {
						name: '',
						intro: '',
						category: '',
						picture: [],
						trademark: [],
						permit: null,
						otherfile: []
					}
				}
			},
			dialogVisibleReceivableAdd: false,
			formReceivableAdd: {},
			formReceivableModify: {},
			dialogVisibleReceivableModify: false,
			upload_file: {
				license: null,
				picture: [],
				trademark: [],
				permit: null,
				otherfile: []
			},
			dialogVisible: false,
			dialogImageUrl: ''
		};
	},
	beforecreate: function() {},
	created: function() {
		let server = {};
		for (let i = 0; i < this.serviceItem.formItem.length; i++) {
			server[this.serviceItem.formItem[i].key] = this.serviceItem.formItem[i].value;
			//this.formAdd.service.content[this.serviceItem.formItem[i].key]=this.serviceItem.formItem[i].value;
		}
		this.formAdd.service.content = Object.assign({}, server);
		console.log(this.formAdd.service.content);
	},
	mounted: function() {},
	updated: function() {},
	methods: {
		getProductList() {},
		changeVisibleProduct(val) {
			if (val) {
				if(this.productList.length<1){
					this.loadingProduct = true;
					this.$http.post('/server/index.php?m=order/index&a=getProductList', {  }).then(
						res => {
							this.loadingProduct = false;
							if (res.result == 'ok') {
								this.productList=res.data;
							} else {
								this.$alert(res.msg, {
									title: '操作错误',
									type: 'error'
								});
							}
						},
						err => {
							this.loadingProduct = false;
							if(err){
							this.$alert('网络错误，指定的服务无法访问。', {
								title: '系统错误',
								type: 'error'
							});
							}
						}
					);
				}
			}
		},
		changeProduct(val) {
			for(let i=0;i<this.productList.length;i++){
				if(this.productList[i].id==val){
					this.product=Object.assign({},JSON.parse(JSON.stringify(this.productList[i])));
				}
			}
			console.log(val);
		},
		changeService(val) {
			console.log(val);
		},
		checkCustomerChange(val) {
			this.customer = Object.assign({}, val);
			this.contacter = Object.assign({}, val.contacter);
		},
		checkContacterChange(val) {
			this.contacter = Object.assign({}, val);
		},
		showCheckEmployee(key) {
			this.checkEmployeeShow = true;
			this.checkEmployeeKey = key;
		},
		checkEmployeeClose() {
			this.checkEmployeeShow = false;
		},
		changeEmployee(e) {
			this[e.key] = e.data;
		},
		modifyReceivable(index) {
			console.log(index);
			this.dialogVisibleReceivableModify = true;
		},
		deleteReceivable(index) {
			console.log(index);
		},
		formSubmitReceivableAdd() {
			console.log(this.formReceivableAdd);
			this.$refs['formReceivableAdd'].validate(valid => {
				if (valid) {
					this.formAdd.receivable.push({
						money: this.formReceivableAdd.money,
						receiptDate: this.formReceivableAdd.receiptDate,
						payState: this.formReceivableAdd.payState
					});
				} else {
					console.log('error submit!!');
				}
			});
		},
		formSubmitAdd() {
			console.log(this.formAdd);
			this.$refs['formAdd'].validate(valid => {
				if (valid) {
					if (
						this.formAdd.ext.customer.address ==
						this.CodeToText[this.formAdd.ext.customer.region[0]] +
							this.CodeToText[this.formAdd.ext.customer.region[1]] +
							this.CodeToText[this.formAdd.ext.customer.region[2]]
					) {
						this.$alert('请填写详细地址');
						return false;
					}
					const loading = this.$loading({
						lock: true,
						text: '处理中...',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					this.$http.post('/server/index.php?m=order/add&a=save', { data: this.formAdd }).then(
						res => {
							loading.close();
							if (res.result == 'ok') {
								this.$alert('创建订单成功！', {
									title: '操作成功',
									type: 'success',
									callback: () => {
										this.$router.back(-1);
									}
								});
							} else {
								this.$alert(res.msg, {
									title: '操作错误',
									type: 'error'
								});
							}
						},
						r => {
							loading.close();
							this.$alert('网络错误，指定的服务无法访问。', {
								title: '系统错误',
								type: 'error'
							});
						}
					);
					return false;
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		}
	}
};
</script>

<style></style>
